import {OfferRuleModel} from './offer-rule.model';

export const generatedOfferRuleHandoffVersion = 1;
export const generatedOfferRuleHandoffTtlMs = 600000;
export const generatedOfferRuleStorageNamespace = 'ipopRuleDraft:';
export const generatedOfferRuleTokenMaximumLength = 64;

export interface GeneratedOfferRuleHandoff {
  version: 1;
  token: string;
  accountId: number;
  createdAt: string;
  expiresAt: string;
  rule: OfferRuleModel;
}

export type GeneratedOfferRuleHandoffFailureReason =
  'missing'
  | 'expired'
  | 'malformed'
  | 'accountMismatch'
  | 'storageUnavailable';

export interface GeneratedOfferRuleHandoffSuccess {
  status: 'success';
  rule: OfferRuleModel;
}

export interface GeneratedOfferRuleHandoffFailure {
  status: 'failure';
  reason: GeneratedOfferRuleHandoffFailureReason;
}

export type GeneratedOfferRuleHandoffConsumptionResult =
  GeneratedOfferRuleHandoffSuccess
  | GeneratedOfferRuleHandoffFailure;
